import React, { useEffect } from 'react';
import {
  useQueryParam,
  NumberParam,
  StringParam,
  ArrayParam,
  withDefault
} from 'use-query-params';

import { ApiParams } from '../../../common/api/api';
import PageTemplateCardOver from '../../../common/page-template/PageTemplateCardOver';
import SporListView from '../../purchase/SporListView';
import { Supplier } from '../Supplier.interface';
import { useFindPurchaseOrders } from '../Supplier.hooks';

export interface PurchaseOrderProps {
  supplier: Supplier;
  handleAddItem?: (callback?: () => void) => void;
}

const PurchaseOrderTab: React.FC<PurchaseOrderProps> = (
  props: PurchaseOrderProps
) => {
  const { supplier, handleAddItem } = props;
  const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 0));
  const [limit, setLimit] = useQueryParam(
    'limit',
    withDefault(NumberParam, 100)
  );
  const [order, setOrder] = useQueryParam(
    'order',
    withDefault(StringParam, undefined)
  );
  const [status, setStatus] = useQueryParam(
    'status',
    withDefault<string[], string[]>(ArrayParam as any, [])
  );
  const [orderDirection, setOrderDirection] = useQueryParam(
    'direction',
    withDefault(StringParam, undefined)
  );
  const { data, isLoading, get } = useFindPurchaseOrders();

  useEffect(() => {
    const params: ApiParams = {
      page,
      limit,
      order,
      direction: orderDirection,
      supplierId: supplier.id
    };
    if (status) {
      params.status = status;
    }
    get(params);
  }, [get, status, supplier, page, limit, order, orderDirection]);

  return (
    <PageTemplateCardOver>
      <SporListView
        supplier={supplier}
        setStatus={setStatus as any}
        {...{
          data,
          isLoading,
          setPage,
          setLimit,
          order,
          setOrder,
          status,
          orderDirection,
          setOrderDirection,
          handleAddItem
        }}
      />
    </PageTemplateCardOver>
  );
};

export default PurchaseOrderTab;
